"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.restore = exports.execute = exports.get = exports.setFlag = void 0;
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var fbase_1 = require("../firebase/fbase");
var COLLECTION_NAME = 'BACKUP';
function setFlag() {
    return __awaiter(this, void 0, void 0, function () {
        var maxNumber, backupDocs, today, deleteFlag, deleteTargetDocId, updateFlag, docIdList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    maxNumber = 21;
                    return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME).get()];
                case 1:
                    backupDocs = _a.sent();
                    today = (0, moment_1.default)().format('YYYYMMDD');
                    deleteFlag = false;
                    deleteTargetDocId = '';
                    updateFlag = true;
                    docIdList = [];
                    backupDocs.forEach(function (doc) {
                        var docId = doc.id;
                        docIdList.push(docId);
                        if (docId === today) {
                            updateFlag = false;
                        }
                    });
                    // 개수 체크
                    if (docIdList.length >= maxNumber) {
                        // 제일 오래된걸 지워야함
                        // "init" 은 항상 마지막이라 안지워짐
                        docIdList.sort();
                        deleteFlag = true;
                        deleteTargetDocId = docIdList[0];
                    }
                    if (!updateFlag) return [3 /*break*/, 5];
                    if (!deleteFlag) return [3 /*break*/, 3];
                    return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME).doc(deleteTargetDocId).delete()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME).doc(today).set({ flag: true })];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.setFlag = setFlag;
function get() {
    return __awaiter(this, void 0, void 0, function () {
        var docs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME).get()];
                case 1: return [4 /*yield*/, (_a.sent()).docs];
                case 2:
                    docs = _a.sent();
                    return [2 /*return*/, (0, lodash_1.default)(docs)
                            .map(function (doc) {
                            var data = doc.data();
                            return data.flag && data.startFlag ? doc.id : undefined;
                        })
                            .compact()
                            .value()];
            }
        });
    });
}
exports.get = get;
function getDocuments(collectionRef) {
    return __awaiter(this, void 0, void 0, function () {
        var query;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, collectionRef.get()];
                case 1:
                    query = _a.sent();
                    return [2 /*return*/, lodash_1.default.reduce(query.docs, function (result, doc) {
                            result[doc.id] = doc.data();
                            return result;
                        }, {})];
            }
        });
    });
}
function getCollectionDocuments(collectionNames, rootOrBackupRef) {
    return __awaiter(this, void 0, void 0, function () {
        var docs;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(lodash_1.default.map(collectionNames, function (name) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getDocuments(rootOrBackupRef.collection(name))];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    }); }); }))];
                case 1:
                    docs = _a.sent();
                    return [2 /*return*/, lodash_1.default.zipObject(collectionNames, docs)];
            }
        });
    });
}
function insertData(todayDate, backupData) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // Do Not Use!!
                return [4 /*yield*/, Promise.all(lodash_1.default.map(backupData, function (backup, collectionName) { return __awaiter(_this, void 0, void 0, function () {
                        var collectionRef;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    collectionRef = fbase_1.dbService
                                        .collection(COLLECTION_NAME)
                                        .doc(todayDate)
                                        .collection(collectionName);
                                    return [4 /*yield*/, Promise.all(lodash_1.default.map(backup, function (data, documentId) { return __awaiter(_this, void 0, void 0, function () {
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, collectionRef.doc(documentId).set(data)];
                                                    case 1:
                                                        _a.sent();
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); }))];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }))];
                case 1:
                    // Do Not Use!!
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function execute(todayDate) {
    return __awaiter(this, void 0, void 0, function () {
        var collectionNames, backupData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    collectionNames = ['DEPARTMENT', 'CYCLE', 'PROCESS', 'RISK', 'CONTROL', 'STAFF', 'NOTICE'];
                    return [4 /*yield*/, getCollectionDocuments(collectionNames, fbase_1.dbService)];
                case 1:
                    backupData = _a.sent();
                    return [4 /*yield*/, insertData(todayDate, backupData)];
                case 2:
                    _a.sent();
                    if (!(todayDate === 'init')) return [3 /*break*/, 4];
                    return [4 /*yield*/, fbase_1.dbService
                            .collection(COLLECTION_NAME)
                            .doc(todayDate)
                            .set({
                            flag: true,
                            date: (0, moment_1.default)().format('YYYYMMDD')
                        })];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.execute = execute;
function checkValidation(targetDate) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME).doc(targetDate).get()];
                case 1:
                    data = (_a.sent()).data();
                    return [2 /*return*/, targetDate === 'init' || (data && data.flag && data.startFlag)];
            }
        });
    });
}
function deleteCurrentCollections() {
    return __awaiter(this, void 0, void 0, function () {
        var collectionNames;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    collectionNames = ['DEPARTMENT', 'CYCLE', 'PROCESS', 'RISK', 'CONTROL', 'NOTICE'];
                    return [4 /*yield*/, Promise.all(collectionNames.map(function (collectionName) { return __awaiter(_this, void 0, void 0, function () {
                            var collectionDocs;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, fbase_1.dbService.collection(collectionName).get()];
                                    case 1:
                                        collectionDocs = _a.sent();
                                        return [4 /*yield*/, Promise.all(collectionDocs.docs.map(function (doc) { return __awaiter(_this, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, doc.ref.delete()];
                                                        case 1:
                                                            _a.sent();
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); }))];
                                    case 2:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function insertBackupData(collections) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(lodash_1.default.map(collections, function (collectionData, collectionName) { return __awaiter(_this, void 0, void 0, function () {
                        var collectionRef;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    collectionRef = fbase_1.dbService.collection(collectionName);
                                    return [4 /*yield*/, Promise.all(lodash_1.default.map(collectionData, function (document, documentId) { return __awaiter(_this, void 0, void 0, function () {
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, collectionRef.doc(documentId).set(document)];
                                                    case 1:
                                                        _a.sent();
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); }))];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function restore(targetDate) {
    return __awaiter(this, void 0, void 0, function () {
        var valid, collectionNames, dataFromTargetDate;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, checkValidation(targetDate)];
                case 1:
                    valid = _a.sent();
                    if (!valid) {
                        return [2 /*return*/, Promise.reject(new Error("".concat(targetDate, " \uB294 \uBC31\uC5C5\uC774 \uBD88\uAC00\uB2A5\uD55C \uB0A0\uC9DC\uC785\uB2C8\uB2E4.")))];
                    }
                    collectionNames = ['DEPARTMENT', 'CYCLE', 'PROCESS', 'RISK', 'CONTROL', 'NOTICE'];
                    return [4 /*yield*/, getCollectionDocuments(collectionNames, fbase_1.dbService.collection(COLLECTION_NAME).doc(targetDate))];
                case 2:
                    dataFromTargetDate = _a.sent();
                    return [4 /*yield*/, deleteCurrentCollections()];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, insertBackupData(dataFromTargetDate)
                        // TODO: 우리 복구하고나면 STAFF랑 나머지 싱크 안맞는건 어떻게 하기로했더라..
                    ];
                case 4:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.restore = restore;
//# sourceMappingURL=BackupManager.js.map